module.exports = __webpack_public_path__ + "img/border3.1a7c902f.png";